class TaiaProductGallery {
  constructor(gallery) {
    this.gallery = gallery;
    this.list = gallery.querySelector('.product__media-list');
    this.slides = Array.from(gallery.querySelectorAll('.product__media-item'));
    this.dots = Array.from(gallery.querySelectorAll('[data-taia-media-dot]'));
    if (!this.list || !this.slides.length || !this.dots.length) return;

    this.dots.forEach((dot) => {
      dot.addEventListener('click', () => {
        const slide = this.slides[Number(dot.dataset.taiaMediaDot)];
        if (slide) slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
      });
    });

    this.observer = new IntersectionObserver(
      (entries) => {
        const visible = entries
          .filter((entry) => entry.isIntersecting)
          .sort((a, b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (!visible) return;
        const index = this.slides.indexOf(visible.target);
        this.setActive(index);
      },
      { root: this.list, threshold: [0.45, 0.7] }
    );
    this.slides.forEach((slide) => this.observer.observe(slide));
  }

  setActive(index) {
    this.dots.forEach((dot, dotIndex) => {
      const active = dotIndex === index;
      dot.classList.toggle('is-active', active);
      if (active) dot.setAttribute('aria-current', 'true');
      else dot.removeAttribute('aria-current');
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('media-gallery').forEach((gallery) => new TaiaProductGallery(gallery));
});
